import axios from "axios";
import { useQuery } from "react-query";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

export const searchSubProducerCodeCriteria = async (searchInputsData) => {
  const franchiseValue = searchInputsData.selectedFranchiseConfie?.value;

  const data = {
    carrierName: searchInputsData.CarrierName,

    officeName: searchInputsData.OfficeName ?? [],
    officeCode: searchInputsData.OfficeCode ?? [],
    states: searchInputsData.State ?? [],
    status: searchInputsData.Status ?? [],

    producerCode: searchInputsData.ProducerCode ?? "",
    maProducerCode: searchInputsData.MAProducerCode ?? "",

    isFranchise: franchiseValue === 2,
    isConfie: franchiseValue === 1,
    isConfieFranchise: franchiseValue === 3,
    isFranchiseType: franchiseValue === 4,

    acquisitionName: searchInputsData.AcquisitionName ?? "",

    carrierProducerCodes: searchInputsData.carrierProducerCodes ?? null,

    carrier: searchInputsData.carrierProducerCodes?.carrierName,

    billingId: searchInputsData.BillingId ?? null,

    distributionChannelId: searchInputsData.DistributionChannelId ?? null,
  };

  const res = await axios.post(`${api_base_url}/SubSearchProducerCode`, data);

  return res.data;
};

export const useSubSearch = ({ filterParams }) => {
  return useQuery(
    ["SearchSubProducerCodeCriteria", filterParams],
    () => searchSubProducerCodeCriteria(filterParams),
    {
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );
};
